$.fn.raty.defaults = $.extend $.fn.raty.defaults,
  path: ''
  space: false
  hints: ["ungenießbar","trinkbar","mittelmäßig","schmeckt gut","super lecker"]
  cancelHint: "Bewertung löschen"

  {}
